import { AxiosResponse } from "axios";
import HttpNotFoundException from "@rmp/core/exceptions/httpNotFoundException";
import { classifyError } from "@rmp/core/api/errors/classifyError";

export async function safeFetch<T, U>(cb: () => Promise<AxiosResponse<T, U>>) {
	try {
		return (await cb()).data;
	} catch (error) {
		if(classifyError(error) instanceof HttpNotFoundException) {
			return null;
		} else {
			throw error;
		}
	}
}

export async function strictFetch<T, U>(cb: () => Promise<AxiosResponse<T, U> | { data: T }>) {
	try {
		return (await cb()).data;
	} catch (error) {
		throw classifyError(error);
	}
}
